import database from "../../assets/images/database sourcing.png";
import finance from "../../assets/images/team finance management.png";
import hr from "../../assets/images/talent-management.png";
import communication from "../../assets/images/speech-bubble.png";

const listData = {
  "serviceCards": [
    {
      "title": "Sourcing & Stock Management",
      "image": database,
      "items": [
        "Supply Chain Management",
        "Inventory Management"
      ]
    },
    {
      "title": "Corporate Finance Management",
      "image": finance,
      "items": [
        "Cash Collection Software",
        "Treasury Management"
      ]
    },
    {
      "title": "HR, Talent & Productivity Management",
      "image": hr,
      "items": [
        "Onboarding Management",
        "Employee Performance Management & Monitoring"
      ]
    },
    {
      "title": "Communication",
      "image": communication,
      "items": [
        "Customer Portals",
        "Partner Portals"
      ]
    }
  ]
};

export default listData;
